// @flow
import { css } from "styled-components";
import { media } from "@nested/brand";
import { StampDutyCalculator as StampDutyCalculatorComponent } from "../../components/StampDutyCalculator/StampDutyCalculator";
import { whiteSliceAdjacentSliceRules } from "../AdjacentSliceRules/AdjacentSliceRules";

const wrapper = css`
  ${whiteSliceAdjacentSliceRules};
  max-width: 1140px;
  margin: auto;
  padding: 40px 0px 30px;
  ${media.desktop`
    padding: 80px 0px 80px;
  `}
`;

type Props = {
  introductionText: PrismicRichText,
  title: PrismicRichText,
  buttonText: string,
};

export const StampDutyCalculator = ({
  title,
  introductionText,
  buttonText,
}: Props) => {
  return (
    <div css={wrapper}>
      <StampDutyCalculatorComponent
        introductionText={introductionText}
        title={title}
        buttonText={buttonText}
      />
    </div>
  );
};
